export const SEND_BULK_REQUEST = 'SEND_BULK_REQUEST';
export const SEND_BULK_SUCCESS = 'SEND_BULK_SUCCESS';
export const SEND_BULK_FAILURE = 'SEND_BULK_FAILURE';
export const CLEAR_BULK_RESULT = 'CLEAR_BULK_RESULT';

export const sendBulkRequest = (imeis, actionType) => ({
    type: SEND_BULK_REQUEST,
    payload: { imeis, actionType }
});

export const sendBulkSuccess = summary => ({
    type: SEND_BULK_SUCCESS,
    payload: { summary }
});

export const sendBulkFailure = error => ({
    type: SEND_BULK_FAILURE,
    payload: { error }
});

export const clearBulkResult = () => ({ type: CLEAR_BULK_RESULT });
